import React from "react";

import "./OrderDetails.css";

import { Text, Subtitle } from "./../../../StyledComponents";

export default (props) => {
  return (
    <React.Fragment>
      <Subtitle automationid="SalesLead_H4_OrderDetails_1">
        Order details
      </Subtitle>
      <div
        className="new-customer-success__order-details"
        automationid="SalesLead_Div_OrderDetails_1"
      >
        <div automationid="SalesLead_Div_OrderDetails_2">
          <Text fontWeight="500" automationid="SalesLead_P_OrderDetails_1">
            Delivery address:
          </Text>
          <Text automationid="SalesLead_P_OrderDetails_2">
            {props.deliveryAddress}
          </Text>
        </div>
        <div automationid="SalesLead_Div_OrderDetails_4">
          <Text automationid="SalesLead_P_OrderDetails_4" fontWeight="500">
            Contact person:
          </Text>
          <Text automationid="SalesLead_P_OrderDetails_5">{props.contactPerson}</Text>
        </div>
        {
          props?.referenceNumber ?
            <div automationid="SalesLead_Div_OrderDetails_6">
              <Text automationid="SalesLead_P_OrderDetails_7" fontWeight="500">
                Reference number:
              </Text>
              <Text automationid="SalesLead_P_OrderDetails_8">{props.referenceNumber}</Text>
            </div>
          :
            null
        }

      </div>
    </React.Fragment>
  );
};
